import axios from 'axios' // Import the axios library

const kmsat_origin_el = document.querySelector('meta[name="kmsat-origin"]')
const kmsat_origin = kmsat_origin_el && kmsat_origin_el.content

if (!kmsat_origin) {
  console.error('CCM: kmsat-origin is not configured — postMessage is disabled to prevent wildcard origin vulnerability')
}

window.addEventListener('message', event => {
  if (!kmsat_origin || event.origin !== kmsat_origin) {
    return
  }

  if (isJsonString(event.data)) {
    const response = JSON.parse(event.data)
    document.cookie = `locale=${response.locale}`
    if (response.authToken) {

      const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${response.authToken}` // add the auth token to Authorization header
      }
      axios.get('/', { headers }) // Use axios to make the GET request
        .then(response => {
          if (!kmsat_origin) {
            console.error('CCM: cannot send page-reload-iframe — kmsat-origin is not configured')
            return
          }
          window.parent.postMessage('page-reload-iframe', kmsat_origin)
        })
        .catch(error => {
          console.error('CCM Connection Error!')
        })
    }
  }
})

function isJsonString(str) {
  if (typeof str !== 'string') {
    return false
  }
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}
